import {
	Button as ButtonMui,
	ButtonProps as ButtonPropsMui,
} from '@mui/material';

import styled from 'styled-components';

export type ButtonProps = ButtonPropsMui & { component?: string };

const StyledButton = styled(ButtonMui)``;

const Button: React.FC<ButtonProps> = props => {
	return (
		<StyledButton
			{...props}
			disableElevation
			disableFocusRipple
			disableTouchRipple
			disableRipple
		>
			{props.children}
		</StyledButton>
	);
};

export default Button;
